import { render } from "./EditorBoxPaintBucket.vue?vue&type=template&id=23144751&scoped=true"
import script from "./EditorBoxPaintBucket.vue?vue&type=script&lang=js"
export * from "./EditorBoxPaintBucket.vue?vue&type=script&lang=js"

import "./EditorBoxPaintBucket.vue?vue&type=style&index=0&id=23144751&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23144751"

export default script